import { Action, createReducer, on } from '@ngrx/store';
import {
  setHomeFilterString,
  setHomeSortingDirection,
  setHomeSortingField,
  setHomeTab,
} from '../actions/home.actions';

import { SortDirection } from '../constants';
import { loginSuccess } from '../actions/auth.actions';

export interface HomeState {
  tab: 'recent' | 'active' | 'archived' | 'deleted';
  filterString?: string;
  sortField?: string;
  sortDirection?: SortDirection;
}

export const initialState: HomeState = {
  tab: 'active',
  filterString: '',
  sortField: 'title',
  sortDirection: 'asc',
};

const _homeReducer = createReducer(
  initialState,
  on(setHomeFilterString, (state, { filterString }) => {
    return {
      ...state,
      filterString,
    };
  }),
  on(setHomeSortingField, (state, { sortingField }) => {
    return {
      ...state,
      sortField: sortingField,
    };
  }),

  on(setHomeSortingDirection, (state, { sortingDirection }) => {
    return {
      ...state,
      sortDirection: sortingDirection,
    };
  }),
  on(setHomeTab, (state, { tab }) => {
    return {
      ...state,
      tab,
    };
  }),

  on(loginSuccess, (state, { response }) => {
    // Safely access nested properties and provide fallback values for undefined fields
    const user = response.user;
    const objectManagerHome = user?.context_settings?.['object_manager_home'];

    return {
      ...state,
      sortField: objectManagerHome?.sortingField ?? 'title', // fallback to a default if sortingField is missing
      sortDirection: objectManagerHome?.sortingDirection ?? 'asc', // fallback to 'asc' if sortingDirection is missing
    };
  }),
);

export function homeReducer(state: HomeState, action: Action) {
  return _homeReducer(state, action);
}
